export class Validation {

  static isValidGuid(expression: string): boolean {
    if (expression != null) {
      const guidRegEx = new RegExp('^(\{{0,1}([0-9a-fA-F]){8}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){4}-([0-9a-fA-F]){12}\}{0,1})$');
      return guidRegEx.test(expression);
    }
    return false;
  }

  static isNullEmptyOrWhiteSpaces(str: string): boolean {
    return str === undefined || str === null || str === '' || str.match(/^ *$/) !== null;
  }
}
